import { createAction } from '@reduxjs/toolkit';

export const setSearchQuery = createAction<string, 'search/SET_QUERY'>('search/SET_QUERY');
export const setIsSearchBarOpen = createAction<boolean, 'search/TOGGLE_SEARCHBAR'>(
  'search/TOGGLE_SEARCHBAR',
);
export const clearSearchBar = createAction('search/CLEAR');
export const toggleSearchBar = createAction('search/TOGGLE_SEARCHBAR_IS_OPEN');
